import {ReactNode} from 'react';
import cn from 'classnames';

import Content from '@/shared/components/Popup/Layout/Content';
import GroupButton from '@/shared/components/Popup/Layout/GroupButton';
import Title from '@/shared/components/Popup/Layout/Title';

type Props = {
  className?: string;
  children: ReactNode;
};

const Layout = ({children, className}: Props) => {
  return (
    <>
      <div className="dimmed_g type2"></div>
      <div className={cn('popup_g', className)}>
        <div className="popup_body">{children}</div>
      </div>
    </>
  );
};
export default Object.assign(Layout, {Title, Content, GroupButton});
